if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener(
          'pointerup',
          (event) => {
            const button = event.target.closest('[data-product-media-direction]');
            if (button && this.contains(button)) event.stopPropagation();
          },
          true
        );
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-product-media-direction]');
          if (!button || !this.contains(button)) return;
          this.showRelativeMedia(button.dataset.productMediaDirection);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.showRelativeMedia(event.key === 'ArrowRight' ? 'next' : 'previous');
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener?.getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId = this.openedBy?.getAttribute('data-media-id')) {
        if (!mediaId) return;
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showRelativeMedia(direction) {
        const mediaItems = Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]')
        );
        const activeIndex = mediaItems.findIndex((element) => element.classList.contains('active'));
        if (activeIndex === -1 || mediaItems.length < 2) return;

        const offset = direction === 'next' ? 1 : -1;
        const nextIndex = (activeIndex + offset + mediaItems.length) % mediaItems.length;
        this.showActiveMedia(mediaItems[nextIndex].getAttribute('data-media-id'));
      }
    }
  );
}
